import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { getBuyingPortfolio } from 'utils';
import useMatchMedia from 'hooks/useMatchMedia';

type SessionLinkProps = {
  listingEnquiryId: string;
  sessionId: string;
};

const SessionLink: React.FC<SessionLinkProps> = ({
  listingEnquiryId,
  sessionId,
}) => {
  const isMobile = useMatchMedia('isMobile');

  const { t } = useTranslation();

  return (
    <Link
      className="ncoded-button ncoded-button--solid"
      to={`${getBuyingPortfolio(listingEnquiryId, 'messaging')}/${sessionId}`}
    >
      {t(isMobile ? 'chat' : 'chatWithBroker')}
    </Link>
  );
};

export default SessionLink;
